<section
  id="establecer-password"
  class="auth-flow auth-flow--hero"
  [class.auth-flow--origen-micro]="authOrigen === 'micro'"
  [class.auth-flow--origen-if]="authOrigen === 'if'"
  [class.auth-flow--activar-password]="isActivacion"
>
  <app-header-public variant="v2" [showAuthButtons]="true" [showRegisterButton]="false"></app-header-public>

  <div class="auth-flow__vigilado" aria-hidden="true">
    <img class="auth-flow__vigilado-img" src="assets/img/Home/hero/Ico_super.svg" alt="" />
  </div>

  <main class="auth-flow__main">
    <div class="auth-flow__hero">
      <div
        class="auth-flow__bg"
        aria-hidden="true"
        [style.background-image]="'url(' + bgDesktop + ')'"
      ></div>

      <div class="auth-flow__visual-mobile" aria-hidden="true">
        <span class="auth-flow__bubble auth-flow__bubble--tl-lg"></span>
        <span class="auth-flow__bubble auth-flow__bubble--tl-sm"></span>
        <img class="auth-flow__visual-mobile-img" [src]="bgMobile" alt="" />
      </div>

      <h1 class="auth-flow__hero-title">{{ titulo }}</h1>

      <span class="auth-flow__bubble auth-flow__bubble--br-lg auth-flow__bubble--desktop" aria-hidden="true"></span>
      <span class="auth-flow__bubble auth-flow__bubble--br-sm auth-flow__bubble--desktop" aria-hidden="true"></span>

      <div class="auth-flow__panel">
        <span class="auth-flow__bubble auth-flow__bubble--tl-lg auth-flow__bubble--desktop" aria-hidden="true"></span>
        <span class="auth-flow__bubble auth-flow__bubble--tl-sm auth-flow__bubble--desktop" aria-hidden="true"></span>

        <h2 class="auth-flow__title auth-flow__title--panel">{{ titulo }}</h2>

        <div class="auth-flow__user-row">
          <span class="auth-flow__user-label">Nombre de usuario</span>
          <span class="auth-flow__user-value" id="nombreUser">{{ username }}</span>
        </div>

        <form class="auth-flow__form" [formGroup]="recodarForm" novalidate>
          <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('contraseña')">
            <label class="auth-flow__label" for="password">Contraseña*</label>
            <div class="auth-flow__password">
              <input id="password" class="auth-flow__control" maxlength="20" formControlName="contraseña"
                [type]="isVisible ? 'text' : 'password'" autocomplete="new-password"
                placeholder="Escribe aquí"
                [class.is-invalid]="validateField('contraseña')" />
              <button class="auth-flow__password-toggle" type="button" (click)="showPassword('Password')"
                [attr.aria-label]="isVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <span [class]="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </button>
            </div>
            <div class="auth-flow__error">
              Campo obligatorio (Debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 caracter
              especial (&#64;$+#!%*?&-/_.,))
            </div>
            @if (recodarForm.controls['contraseña'].hasError('confirmPasswordMatch')) {
            <div class="auth-flow__error auth-flow__error--block">Las contraseñas no coinciden</div>
            }
          </div>

          <div class="auth-flow__field" [class.auth-flow__field--invalid]="validateField('confirmarContrasena')">
            <label class="auth-flow__label" for="confirmPassword">Confirmar contraseña*</label>
            <div class="auth-flow__password">
              <input id="confirmPassword" class="auth-flow__control" formControlName="confirmarContrasena"
                [type]="isVisibleConfirm ? 'text' : 'password'" autocomplete="new-password"
                placeholder="Escribe aquí"
                [class.is-invalid]="validateField('confirmarContrasena')" />
              <button class="auth-flow__password-toggle" type="button" (click)="showPassword('')"
                [attr.aria-label]="isVisibleConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <span [class]="isVisibleConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </button>
            </div>
            @if (recodarForm.controls.confirmarContrasena.hasError('confirmPasswordMatch')) {
            <div class="auth-flow__error auth-flow__error--block">Las contraseñas no coinciden</div>
            }
          </div>

          <div class="auth-flow__actions">
            @if (!token) {
            <button type="button" class="auth-flow__btn auth-flow__btn--primary" [disabled]="!recodarForm.valid"
              (click)="sendOtp()">
              Registrar contraseña
            </button>
            }
            @if (token) {
            <button type="button" class="auth-flow__btn auth-flow__btn--primary" [disabled]="!recodarForm.valid"
              (click)="sendOtpRecordarContrasena()">
              Registrar contraseña
            </button>
            }
            <button type="button" class="auth-flow__btn auth-flow__btn--secondary" (click)="back()">
              Volver
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</section>
